<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          {{ $t('pages.profile.personal.title') }}
        </h4>
        <p class="card-title-desc">
          {{ $t('pages.profile.personal.info') }}
        </p>
        <form>
          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.personal.fullName') }}
              </label>
            </b-col>
            <b-col md="10">
              <b-form-input
                  v-model="form.name"
                  :placeholder="$t('pages.profile.personal.namePlaceholder')"
                  :class="{
                        'is-invalid': personalSubmitted && $v.form.name.$error,
                      }"
              ></b-form-input>
              <div v-if="personalSubmitted && $v.form.name.$error"
                   class="invalid-feedback d-flex"
              >
                <span v-if="!$v.form.name.required">
                  {{ $t('pages.profile.personal.validations.name.required') }}
                </span>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.personal.email') }}
              </label>
            </b-col>
            <b-col md="10">
              <b-form-input
                  v-model="form.email"
                  :placeholder="$t('pages.profile.personal.emailPlaceholder')"
                  :class="{
                        'is-invalid': personalSubmitted && $v.form.email.$error,
                      }">
              </b-form-input>
              <div v-if="personalSubmitted && $v.form.email.$error"
                   class="invalid-feedback d-flex"
              >
                <span v-if="!$v.form.email.required">
                  {{ $t('pages.profile.personal.validations.email.required') }}
                </span>
                <span v-if="!$v.form.email.email">
                  {{ $t('pages.profile.personal.validations.email.valid') }}
                </span>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.personal.phone') }}
              </label>
            </b-col>
            <b-col md="10">
              <VuePhoneNumberInput
                  color="#f46a6a"
                  valid-color="#34c38f"
                  :translations="translations"
                  v-model="form.phone_number"
                  @update="handlePhoneNumber"
              />
              <div v-if="personalSubmitted && !phoneNumberValid"
                   class="invalid-feedback d-flex"
              >
                {{ $t('pages.profile.personal.validations.phone.valid') }}
              </div>
            </b-col>
          </b-row>

        </form>
        <div class="row mb-3">
          <b-col cols="12" align="end">
            <b-btn variant="success" @click="updatePersonalInformation">
              <i class="mdi mdi-content-save" style="margin-right: 6px;"></i>
              {{ $t('pages.profile.updateBtn') }}
            </b-btn>
          </b-col>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          {{ $t('pages.profile.password.title') }}
        </h4>
        <p class="card-title-desc">
          {{ $t('pages.profile.password.info') }}
        </p>
        <form>
          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.password.currentPassword') }}
              </label>
            </b-col>
            <b-col md="10">
              <b-form-input
                  v-model="password.old_password"
                  type="password"
                  :placeholder="$t('pages.profile.password.currentPasswordPlaceholder')"
                  :class="{
                        'is-invalid': passwordSubmitted && $v.password.old_password.$error,
                      }"
              ></b-form-input>
              <div v-if="passwordSubmitted && $v.password.old_password.$error"
                   class="invalid-feedback"
              >
                <span v-if="!$v.password.old_password.minLength">
                      {{
                    $t('pages.profile.password.validations.currentPassword.min', {min: $v.password.old_password.$params.minLength.min})
                  }}
                </span>
                <span v-if="!$v.password.old_password.required">
                  {{ $t('pages.profile.password.validations.currentPassword.required') }}
                </span>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.password.newPassword') }}
              </label>
            </b-col>
            <b-col md="10">
              <b-form-input
                  v-model="password.new_password"
                  type="password"
                  :placeholder="$t('pages.profile.password.newPasswordPlaceholder')"
                  :class="{
                        'is-invalid': passwordSubmitted && $v.password.new_password.$error,
                      }"
              ></b-form-input>
              <div v-if="passwordSubmitted && $v.password.new_password.$error"
                   class="invalid-feedback d-flex"
              >
              <span v-if="!$v.password.new_password.minLength" class="d-flex">
                {{
                  $t('pages.profile.password.validations.newPassword.min', {min: $v.password.new_password.$params.minLength.min})
                }}
                </span>
                <span v-if="!$v.password.new_password.required" class="d-flex">
                  {{ $t('pages.profile.password.validations.newPassword.required') }}
                </span>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col md="2">
              <label>
                {{ $t('pages.profile.password.confirmPassword') }}
              </label>
            </b-col>
            <b-col md="10">
              <b-form-input
                  v-model="password.confirm_password"
                  type="password"
                  :placeholder="$t('pages.profile.password.confirmPasswordPlaceholder')"
                  :class="{
                        'is-invalid': passwordSubmitted && $v.password.confirm_password.$error,
                      }"
              ></b-form-input>
              <div v-if="passwordSubmitted && $v.password.confirm_password.$error"
                   class="invalid-feedback"
              >
                 <span v-if="!$v.password.confirm_password.required">
                  {{ $t('pages.profile.password.validations.confirmPassword.required') }}
                </span>
                <span v-else-if="!$v.password.confirm_password.sameAsPassword">
                  {{ $t('pages.profile.password.validations.confirmPassword.sameAs') }}
                </span>
              </div>
            </b-col>
          </b-row>

        </form>

        <div class="row mb-3">
          <b-col cols="12" align="end">
            <b-btn variant="success" @click="updateUserPassword">
              <i class="mdi mdi-content-save" style="margin-right: 6px;"></i>
              {{ $t('pages.profile.updateBtn') }}
            </b-btn>
          </b-col>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import UserService from "../../../Services/Api/UserService";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import {
  required,
  email,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: "Form",
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone_number: '',
      },
      password: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      translations: {
        countrySelectorLabel: this.$t('pages.login.country_code'),
        countrySelectorError: this.$t('pages.login.choose_country'),
        phoneNumberLabel: this.$t('pages.login.phone_number'),
        example: this.$t('common.example'),
      },
      user: null,
      personalSubmitted: false,
      passwordSubmitted: false,
      phoneNumberValid: true,
      phoneNumber: null
    }
  },
  validations: {
    form: {
      name: {required},
      email: {required, email},
    },
    password: {
      old_password: {required, minLength: minLength(6)},
      new_password: {required, minLength: minLength(6)},
      confirm_password: {required, sameAsPassword: sameAs("new_password")}
    }
  },
  methods: {
    handlePhoneNumber(e) {
      if (!e.formattedNumber) {
        this.phoneNumberValid = true
        this.phoneNumber = true
      } else {
        this.phoneNumberValid = e.isValid
        this.phoneNumber = e.formattedNumber
      }
    },
    setVariables() {
      this.$auth.load().then(() => {
        this.user = this.$auth.user()
        this.form.name = this.user?.name
        this.form.email = this.user?.email
        this.form.phone_number = this.user?.phone_number
      })
    },
    async updateUserPassword() {
      this.passwordSubmitted = true
      this.$v.$touch()

      if (this.$v.password.$error) {
        return false
      } else {
        const payload = {
          'old_password': this.password.old_password,
          'new_password': this.password.new_password,
        }
        await UserService.updatePassword({payload})
      }
    },
    async updatePersonalInformation() {
      this.personalSubmitted = true
      this.$v.$touch();

      if (this.$v.form.$error || !this.phoneNumberValid) {
        return false
      } else {
        const payload = {
          'name': this.form.name,
          'phone_number': this.form.phone_number,
          'email': this.form.email,
        }
        await UserService.update({id: this.user.id, payload}).then(() => {
          this.$auth.fetch()
        }).finally(() => {
          this.personalSubmitted = false
        })
      }
    }
  },
  mounted() {
    this.setVariables()
  }
}
</script>

<style scoped>

</style>